import 'ol/ol.css';
import Map from 'ol/Map';
//! [import]
import ImageLayer from 'ol/layer/Image';
import RasterSource from 'ol/source/Raster';
//! [import]
import TileLayer from 'ol/layer/Tile';
import View from 'ol/View';
import XYZSource from 'ol/source/XYZ';
import {fromLonLat} from 'ol/proj';


const opensea = new XYZSource({
     url: 'https://t1.openseamap.org/seamark/{z}/{x}/{y}.png',
  });



const key = 'pk.eyJ1Ijoiam9qb2hlZSIsImEiOiJja3ExNHJrYTIwNHdjMm9rdzQ3OGNodzZwIn0.cTcf8hozfGYNZnjI5Oxt-g';
const elevation = new XYZSource({
  url: 'https://api.mapbox.com/v4/mapbox.terrain-rgb/{z}/{x}/{y}.pngraw?access_token=' + key,
  crossOrigin: 'anonymous'
});



//! [flood]
function flood(pixels, data) {
  const pixel = pixels[0];
  if (pixel[3]) {

    // decode R, G, B values as elevation
    const height = -10000 + ((pixel[0] * 256 * 256 + pixel[1] * 256 + pixel[2]) * 0.1);
      pixel[0] =  296-pixel[0]; // red
      pixel[1] =  296-pixel[1];  // green
      pixel[2] =  296-pixel[2];  // blue
      pixel[3] =  pixel[3]; // alpha
    if (height <= data.level) {
      // sea blue
      pixel[0] = 237+pixel[0]; // red
      pixel[1] =  28+pixel[1]; // green
      pixel[2] =  36+pixel[2]; // blue
      pixel[3] =  pixel[3]; // alpha
    } else {
      // transparent
     // pixel[3] = 0;
      pixel[3] = pixel[3];
    }
  }
  return pixel;
}
//! [flood]

//! [raster]
const raster = new RasterSource({
  sources: [elevation],
  operation: flood
});
//! [raster]



//auto data.level
const control = document.getElementById('levelslide');
const output = document.getElementById('output');

var level = 0;
var i = 0;
var up = 1;

 
Levelsea();

  function Levelsea() {
  //console.log(up);
  output.innerText= level;
  document.getElementById("levelslide").value = level;
  

 
    if (level >= 6800 ) {


    up = 0;
    setTimeout(Levelseadown, 200);
		return level;
       }
  else {

    i++
      level=((i/40)*(i/40)*(i/40)*(i/40)*(i/40)*(i/40)); 
      level=parseFloat(level).toFixed( 2 )
     // console.log(level);
      raster.changed();
      setTimeout(Levelsea, 200);
       return level;
    }
  };
 
  function Levelseadown() {
  
  output.innerText= level;
  document.getElementById("levelslide").value = level;
    if (level <= 0) {
    up = 1;
    i = 0;
    level = 0;
    raster.changed();
   setTimeout(Levelsea, 200);
   return level;
       }
  else {
  
    i--
      level=((i/40)*(i/40)*(i/40)*(i/40)*(i/40)*(i/40)); 
      level=parseFloat(level).toFixed( 2 )
  //     console.log(level);
      raster.changed();
      setTimeout(Levelseadown, 200);
       return level;
    }
  };



//! [beforeops]
raster.on('beforeoperations', function(event) {
  event.data.level = control.value;
});
//! [beforeops]

new Map({
  target: 'map-container',
  layers: [

    //! [layer]
    new ImageLayer({
      opacity: 0.8,
      source: raster
    })
    ,
     new TileLayer({
      source: opensea,
      opacity: 1.0
    })

    //! [layer]
  ],
  view: new View({
    center: fromLonLat([0, 30]),
    zoom: 0
  })
});
